var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { forwardRef } from 'react';
import { Button as ArcoButton } from '@arco-design/web-react';
import { useConfigContext } from '@m4b-design/config-provider';
import cx from 'classnames';
import { useControlled } from './hooks/use-controlled';
import './style/toggle.less';
var ToggleButtonRender = function ToggleButtonRender(props, ref) {
  var controlProps = {
    defaultValue: props.defaultChecked || false
  };
  if ('checked' in props) {
    controlProps.value = props.checked;
  }
  var _a = __read(useControlled(controlProps), 2),
    value = _a[0],
    setValue = _a[1];
  var globalPrefixCls = useConfigContext().prefixCls;
  var prefixCls = "".concat(globalPrefixCls, "-button-toggle");
  var innerOnClick = function innerOnClick(e) {
    var _a, _b;
    (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
    setValue(function (prev) {
      return !prev;
    });
    (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, !value, e);
  };
  return /*#__PURE__*/React.createElement(ArcoButton, __assign({
    "data-tid": "m4b_button_toggle_button"
  }, props, {
    onClick: innerOnClick,
    className: cx(prefixCls, props.className, value && "".concat(prefixCls, "-checked")),
    ref: ref
  }), typeof props.children === 'function' ? props.children(value) : props.children);
};
var ToggleButton = /*#__PURE__*/forwardRef(ToggleButtonRender);
ToggleButton.displayName = 'Button.ToggleButton';
export default ToggleButton;